<script>
export default {
  name: 'SkiSchoolLevel',
  props: {
    level: {
      type: Object,
      required: true,
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      levelItem: Object.assign({}, this.level),
    };
  },
  methods: {
    onLevelChange(params) {
      this.$emit('onLevelChange', {
        levelItem: this.levelItem,
        params,
      });
      if (params.priority) {
        this.$nextTick(() => {
          const element = 'priority'.concat(this.levelItem.priority);
          this.$refs[element].focus();
        });
      }
    },
  },
  watch: {
    level: {
      deep: true,
      handler() {
        this.levelItem = Object.assign({}, this.level);
      },
    },
  },
};
</script>

<template>
  <v-container class="pa-0">
    <v-layout wrap>
      <v-flex class="text-xs-right pr-4 pt-3" sm1 xs12>
        <h3 :class="{'red--text': !levelItem.id}">
          {{ levelItem.id ? '#' + levelItem.id : $t('buttons.new') }}
        </h3>
      </v-flex>
      <v-flex sm2 xs12>
        <v-text-field
          @input="onLevelChange({ nameSupplier: $event })"
          v-model="levelItem.externalName"
          :placeholder="$t('ski.skiLevel.nameSupplier')"
          :disabled="saveLoading"
          solo
        />
      </v-flex>
      <v-flex sm2 xs12>
        <v-text-field
          @input="onLevelChange({ nameWeb: $event })"
          v-model="levelItem.name"
          :placeholder="$t('ski.skiLevel.nameWebsite')"
          :disabled="saveLoading"
          solo
        />
      </v-flex>
      <v-flex sm1 xs12>
        <v-text-field
          @input="onLevelChange({ priority: $event })"
          v-model="levelItem.priority"
          :placeholder="$t('ski.skiLevel.priority')"
          :disabled="saveLoading"
          :ref="'priority' + levelItem.priority"
          type="Number"
          max="99"
          min="0"
          solo
        />
      </v-flex>
      <v-flex sm1 xs12 class="pl-2 pt-0">
        <v-btn
          @click="$emit('createOrUpdate', level)"
          :disabled="saveLoading"
          class="mb-2"
          color="green"
          small
          outline
        >
          {{ level.id ? $t('buttons.save') : $t('buttons.create') }}
        </v-btn>
      </v-flex>
      <v-flex sm1 xs12 class="pl-4 pt-0">
        <v-btn
          @click="$emit('remove', level.id)"
          :disabled="saveLoading"
          :color="level.id ? 'error' : 'warning'"
          class="mb-2"
          small
          outline
        >
          {{ level.id ? $t('buttons.remove') : $t('buttons.cancel') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/ski/school/SkiSchoolLevel.vue